module.exports = __webpack_public_path__ + "img/gameresult.ba94ff69.jpg";